import React from 'react';
import { UsersIcon, GraduationCapIcon, HeartIcon } from 'lucide-react';
import { governanceRoles, educationItems, volunteerItems } from '../../data/boardEducation';
export function BoardEducationContent() {
  return <div className="space-y-16" data-id="element-71" data-mp="1ble17wcxlz3q">
      <div data-id="element-72" data-mp="1bmp5rye7bavw">
        <div className="flex items-center gap-2.5" data-id="element-73" data-mp="1bmfmsurkq3zp">
          <UsersIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-74" data-mp="16mtb4pre8vt0" />
          <h2 className="font-heading text-lg font-semibold text-navy" data-id="element-75" data-mp="23c0m53udzmio">Governance Leadership</h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-76" data-mp="1zb8ci9hlrflv">
          {governanceRoles.map(role => <div key={role.title + role.org} className="rounded-xl border border-slate-200 bg-white p-7 transition-colors duration-200 hover:border-brandgreen/50" data-id="element-77" data-mp="1ui5r4omzbcgr">
              <h3 className="font-heading text-base font-semibold text-navy" data-id="element-78" data-mp="2n1b0oeiec1f7">{role.title}</h3>
              <p className="mt-1 text-sm font-medium text-brandgreen" data-id="element-79" data-mp="2i89mk8q0k5wo">{role.org}</p>
              <p className="mt-2 text-xs font-medium uppercase tracking-wide text-slate-500" data-id="element-80" data-mp="3bjozdrp2nfg2">{role.period}</p>
              <p className="mt-4 text-sm leading-relaxed text-charcoal" data-id="element-81" data-mp="3ggfeoct1y70f">{role.description}</p>
            </div>)}
        </div>
      </div>

      <div data-id="element-82" data-mp="36rxfu14c29zf">
        <div className="flex items-center gap-2.5" data-id="element-83" data-mp="36rp0m2kqmsl2">
          <GraduationCapIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-84" data-mp="36q49kmxmtrry" />
          <h2 className="font-heading text-lg font-semibold text-navy" data-id="element-85" data-mp="2sre86v3s55xs">Academic Credentials</h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-86" data-mp="2xstu0pds7gh8">
          {educationItems.map(item => <div key={item.degree} className="rounded-xl border border-slate-200 bg-ice p-7" data-id="element-87" data-mp="2jtki41wlz8j2">
              <h3 className="font-heading text-base font-semibold text-navy" data-id="element-88" data-mp="2ntcqadi3bcnw">{item.degree}</h3>
              <p className="mt-1 text-sm font-medium text-brandgreen" data-id="element-89" data-mp="i0w91bxa9qvd">{item.school}</p>
              <ul className="mt-4 space-y-2" data-id="element-90" data-mp="m16g6rwtanbt">
                {item.details.map(detail => <li key={detail} className="flex gap-2.5 text-sm leading-relaxed text-charcoal" data-id="element-91" data-mp="1uzg3of2c16v8">
                    <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-navy" aria-hidden="true" data-id="element-92" data-mp="1pys7zg35s1uo" />
                    {detail}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      <div data-id="element-93" data-mp="2dp4r7n3utl0k">
        <div className="flex items-center gap-2.5" data-id="element-94" data-mp="2dowebv7qefpd">
          <HeartIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-95" data-mp="2docw0de65pat" />
          <h2 className="font-heading text-lg font-semibold text-navy" data-id="element-96" data-mp="29oub3hmcle7z">Volunteer Service</h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-97" data-mp="24vjbo1jv7zq3">
          {volunteerItems.map(item => <div key={item.title} className="rounded-xl border border-slate-200 bg-white p-7" data-id="element-98" data-mp="1zxhiuown0m1f">
              <h3 className="font-heading text-base font-semibold text-navy" data-id="element-99" data-mp="2xeollsj72qp2">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-charcoal" data-id="element-100" data-mp="2sku6z3ig51wu">{item.description}</p>
            </div>)}
        </div>
      </div>
    </div>;
}